import React from 'react'

function Version() {
  return (
    <div className='text-center py-5 text-3xl'>
      Released Candidate Version - 1.0.0
    </div>
  )
}

export default Version
